import React from 'react';
import SectorMapTab from '../components/analysts/SectorMapTab';
import { useNavigate } from 'react-router-dom';

export default function SectorMapPage() {
  const navigate = useNavigate();

  function handleSectorClick({ label, level }) {
    const param = level === 'industry' ? 'industry' : 'sector';
    navigate(`/leaderboard?${param}=${encodeURIComponent(label)}`);
  }

  return (
    <div className="flex flex-col h-full bg-gray-50 p-4 md:p-6 overflow-hidden">
      <div className="mb-4 flex-shrink-0">
        <h1 className="text-2xl font-bold text-gray-900">Sector Map</h1>
        <p className="text-sm text-gray-500 mt-1">
          Where are analysts most active — and most accurate?
        </p>
      </div>
      <div className="flex-1 min-h-0 bg-white rounded-xl border border-gray-200 p-5 flex flex-col">
        <SectorMapTab onSectorClick={handleSectorClick} />
      </div>
    </div>
  );
}
